var Ribrit = {

    flexslider: {

        full: function () {
            $('.flexslider.full').flexslider({
                animation: "slide",
                prevText: '',
                nextText: '',
                before: function (slider) {
                    $(slider).find(".flex-active-slide").find('.caption').each(function () {
                        $(this).find('.title').removeClass("animated bounceIn");
                        $(this).find('.description').removeClass("animated fadeInUp");
                    });
                },
                after: function (slider) {
                    $(slider).find(".flex-active-slide").find('.caption .title').addClass("animated bounceIn");
                    $(slider).find(".flex-active-slide").find('.caption .description').addClass("animated fadeInUp");
                }
            });
        },

        carousel: function () {
            $('.flex-carousel').flexslider({
                animation: "slide",
                animationLoop: false,
                itemWidth: 210,
                itemMargin: 6,
                prevText: '',
                nextText: ''
            });
        },

        thumb: function () {
            $('.flexslider-thumb').flexslider({
                animation: "slide",
                prevText: '',
                nextText: '',
                controlNav: "thumbnails"
            });
        },

        run: function () {
            Ribrit.flexslider.full();
            Ribrit.flexslider.carousel();
            Ribrit.flexslider.thumb();
        }
    },

    magnific: {
        full: function () {
            $('.images .image, .slides.popup li').magnificPopup({
                delegate: 'a',
                type: 'image',
                tLoading: 'Resim Yukleniyor ...',
                mainClass: 'mfp-img-mobile',
                gallery: {
                    enabled: true,
                    navigateByImgClick: true,
                    preload: [
                        0,
                        1
                    ]
                },
                image: {
                    tError: 'Hata!!! <a href="%url%">#%curr%</a> Resim Yukleniyor...',
                    titleSrc: function (item) {
                        return item.el.attr('title');
                    }
                }
            });
        },

        run: function () {
            Ribrit.magnific.full()
        }
    },

    scrollUp: function () {
        $.scrollUp({
            scrollText: '<i class="fa fa-angle-up"></i>',
            easingType: 'linear',
            scrollSpeed: 900,
            animation: 'fade'
        });
    },

    mainMenu: function () {

        $('.main-menu .nav > li').each(function (key, menu) {
            var menu = $(menu);

            if (menu.data('type') != 'mega') {
                return true;
            }

            var menuLinks = menu.find('ul').first();

            menu.addClass('dropdownTabbed');
            menuLinks.addClass('dropdown-tabbed');

            var data = '';

            menuLinks.find('li').each(function (keyLink, link) {
                var link = $(link);
                data += link.data('process') + '-' + link.data('group') + ',';
            });

            setTimeout(function () {
                $.get(Ayar.link.megaMenu, {data: data}, function (response) {
                    menuLinks.empty();
                    menuLinks.html(response);
                });
            }, 300);
        });

        $("#mobileMenu").mmenu({
            extensions: [
                "shadow-panels",
                "fx-panels-slide-100",
                "border-none",
                "theme-black",
                "fullscreen"
            ],
            offCanvas: {
                //	position 	: "right"
            },
            navbars: {
                content: [
                    "prev",
                    "searchfield",
                    "close"
                ],
                height: 2
            },
            setSelected: true,
            searchfield: {
                resultsPanel: true
            }
        }, {});

        $('ul.navbar-nav li.dropdown').hover(function () {
            $(this).find(' > .dropdown-menu').stop(true, true).delay(200).fadeIn(500);
            $(this).addClass('open');
        }, function () {
            $(this).find(' > .dropdown-menu').stop(true, true).delay(200).fadeOut(500);
            $(this).removeClass('open');
        });

        $(window).scroll(function () {
            if ($(window).scrollTop() >= 41) {
                $(".header-main").addClass('fixed');
                $("body").addClass('header-fixed');
            } else {
                $(".header-main").removeClass('fixed');
                $("body").removeClass('header-fixed');
            }
        });

        window.prettyPrint && prettyPrint();

        $(document).on('click', '.navbar .dropdown-menu', function (e) {
            e.stopPropagation()
        });

        $('ul.dropdown-menu [data-toggle=dropdown]').on('click', function (event) {
            event.preventDefault();
            event.stopPropagation();
            $(this).parent().siblings().removeClass('open');
            $(this).parent().toggleClass('open');
        });

        $('.search-btn').on('click', function (event) {
            event.preventDefault();
            $('#search').addClass('open');
            $('#search > form > input[type="search"]').focus();
        });

        $('#search, #search button.close').on('click keyup', function (event) {
            if (event.target == this || event.target.className == 'close' || event.keyCode == 27) {
                $(this).removeClass('open');
            }
        });

        jQuery('.shop-cart').click(function () {
            jQuery('#dropdown-cart').addClass('active');
            jQuery('body').addClass('show-cart');
            jQuery('body').css("overflow", "hidden");
        });

        jQuery('#dropDownCartCloseBtn').click(function () {
            jQuery('#dropdown-cart').removeClass('active');
            jQuery('body').removeClass('show-cart');
            jQuery('body').css("overflow", "visible");

        });
        jQuery(document).mouseup(function (e) {

            var container = jQuery("#dropdown-cart");

            if (!container.is(e.target) // if the target of the click isn't the container...
                && container.has(e.target).length === 0) // ... nor a descendant of the container
            {
                jQuery('#dropdown-cart').removeClass('active');
                jQuery('body').removeClass('show-cart');
                jQuery('body').css("overflow", "visible");
            }
        });
    },

    socialShare: {

        links: {
            facebook: 'http://www.facebook.com/sharer/sharer.php?u=',
            twitter: 'https://twitter.com/intent/tweet?url=',
            google: 'https://plus.google.com/share?url='
        },

        windowOpen: function (service) {
            return window.open(
                Ribrit.socialShare.links[service] + $('link[rel=canonical]').attr('href'),
                'Social Share',
                'width=500,height=400'
            )
        },

        run: function () {
            $('.share').on('click', function () {
                Ribrit.socialShare.windowOpen($(this).data('type'))
            });
        }
    },

    google: {

        map: function (id) {
            $map      = $(id);
            $location = $map.data('location').split(", ");

            var latlng  = new google.maps.LatLng($location[0], $location[1]);
            var options = {
                scrollwheel: false,
                draggable: false,
                zoomControl: false,
                disableDoubleClickZoom: false,
                disableStandartUI: true,
                zoom: parseInt($map.data('zoom')),
                center: latlng,
                mapTypeId: google.maps.MapTypeId.ROADMAP
            };

            var styles    = [{}];
            var styledMap = new google.maps.StyledMapType(styles, {name: "Styled Map"});
            var map       = new google.maps.Map(document.getElementById($map.attr('id')), options);
            var image     = $map.data('marker');
            var marker    = new google.maps.Marker({
                position: latlng,
                map: map,
                title: $map.data('title'),
                icon: image
            });

            map.mapTypes.set('map_style', styledMap);
            map.setMapTypeId('map_style');
            var contentString = $($map.data('content')).html();

            var infowindow = new google.maps.InfoWindow({content: contentString});
            google.maps.event.addListener(marker, 'click', function () {
                infowindow.open(map, marker);
            });
        },

        run: function () {

        }
    },

    toastr: function (type, message) {
        toastr.options = {
            "closeButton": false,
            "debug": false,
            "newestOnTop": false,
            "progressBar": false,
            "positionClass": "toast-bottom-right",
            "preventDuplicates": false,
            "onclick": null,
            "showDuration": "300",
            "hideDuration": "1000",
            "timeOut": "5000",
            "extendedTimeOut": "1000",
            "showEasing": "swing",
            "hideEasing": "linear",
            "showMethod": "fadeIn",
            "hideMethod": "fadeOut"
        }

        if (type == 'error') {
            toastr.error(message);
        } else if (type == 'success') {
            toastr.success(message);
        } else if (type == 'info') {
            toastr.info(message);
        } else {
            toastr.warning(message);
        }
    },

    form: {
        newsletter: function () {
            $('#subcribeForm').submit(function () {
                $(this).validate({
                    rules: {
                        email: {
                            required: true,
                            email: true
                        }
                    },
                    messages: {
                        email: {
                            required: "Please enter a email",
                            minlength: "Please enter a valid email address"
                        }
                    }
                });

                if ($(this).valid()) {
                    return Ribrit.form.newsletterSend($(this));
                }

                return false;
            });
        },

        newsletterSend: function (form) {
            form.ajaxSubmit({
                url: $(this).attr('action'),
                type: 'post',
                dataType: 'json',
                success: Ribrit.form.response,
                error: Ribrit.form.response
            });

            return false;
        },

        contact: function () {
            $('#contactForm').submit(function () {
                $(this).validate({
                    rules: {
                        author: {
                            required: true,
                        },
                        author: {
                            required: true,
                        },
                        email: {
                            required: true,
                            email: true
                        },
                        subject: {
                            required: true,
                        },
                        message: {
                            required: true,
                        }
                    }
                });

                if ($(this).valid()) {
                    Ribrit.form.contactSend($(this));
                }

                return false;
            });
        },

        contactSend: function (form) {
            form.ajaxSubmit({
                url: $(this).attr('action'),
                type: 'post',
                dataType: 'json',
                success: Ribrit.form.response,
                error: Ribrit.form.response
            });

            return false;
        },

        response: function (response, jqForm) {

            if (response.redirect) {
                window.location = response.redirect;
            }

            if (parent.grecaptcha) {
                parent.grecaptcha.reset();
            }

            if (jqForm == 'error') {
                if (response.status == 402 || response.status == 422) {
                    $.each(JSON.parse(response.responseText), function (i, message) {
                        Ribrit.toastr('error', message);
                    });
                } else {
                    Ribrit.toastr('error', JSON.parse(response.responseText).message);
                }
            } else {
                Ribrit.toastr('success', response.message);
            }

            return false;
        },

        run: function () {
            Ribrit.form.newsletter();
            Ribrit.form.contact();
        }
    },

    cart: {

        params: null,

        list: function () {

            $.getJSON(Ribrit.cart.params.listUrl, {json: 'true'}, function (results) {

                $('.shop-cart span').html(results.total);

                if (results.total > 0) {
                    $('#dropDownCartList .cart-empty').hide();
                    $('#dropDownCartList .actions').show();
                    $('#dropDownCartList .cart-list').empty();
                } else {
                    $('#dropDownCartList .cart-empty').show();
                    $('#dropDownCartList .actions').hide();
                    $('#dropDownCartList .cart-list').empty();
                }

                $('.cart-sub-total-price').html(results.sub_total_format);

                $.each(results.cart, function (key, cart) {
                    $('#dropDownCartList .cart-list').append(''
                        + '<li class="product" id="cart-dropdown-product-' + key + '">'
                        + '<div class="image">'
                        + '<div class="quantity">' + cart.quantity + '</div>'
                        + '<a href="' + cart.product_link + '">'
                        + '<img src="' + cart.image + '" class="img-responsive" alt="product">'
                        + '</a>'
                        + '</div>'
                        + '<div class="meta">'
                        + '<a href="' + cart.product_link + '"><h3>' + cart.title + '</h3></a>'
                        + '<div class="price">' + cart.total_format + '</div>'
                        + '</div>'
                        + '<div class="text-right remove"><a href="javascript:Ribrit.cart.remove(' + key + ')"><i class="fa fa-trash-o"></i></a></div>'
                        + '</li>'
                    );
                });
            });
        },

        add: function (product) {
            $.get(Ribrit.cart.params.addUrl, {product: product}, function (response) {
                Ribrit.cart.list();
                Ribrit.toastr('success', 'Teşekkürler ürününüz başarılı bir şekilde telif sepetinize eklendi!');
            });
        },

        update: function (product) {
            $.get(Ribrit.cart.params.updateUrl, {
                    product: product,
                    quantity: $('#cart-quantity-' + product).val()
                },

                function (response) {
                    $('#cart-total-' + product).html(response.cart[product].total_format);
                    Ribrit.cart.list();
                }
            );
        },

        remove: function (product) {
            $.get(Ribrit.cart.params.removeUrl, {product: product}, function (response) {
                $('#cart-dropdown-product-' + product).remove();
                $('#cart-product-' + product).remove();

                Ribrit.cart.list();
            });
        },

        run: function () {
            Ribrit.cart.params = Ayar.cart;
            Ribrit.cart.list();
        }
    },

    order: {

        formValidate: function () {
            $('#orderForm').submit(function () {
                $(this).validate({
                    rules: {
                        name: {
                            required: true
                        },
                        email: {
                            required: true,
                            email: true
                        },
                        phone: {
                            required: true
                        },
                        address: {
                            required: true
                        },
                        city: {
                            required: true
                        },
                        post_code: {
                            required: true
                        }
                    }
                });

                if ($(this).valid()) {
                    return Ribrit.order.complete($(this));
                }

                return false;
            });
        },

        complete: function (form) {
            form.ajaxSubmit({
                url: $(this).attr('action'),
                type: 'post',
                dataType: 'json',
                success: Ribrit.form.response,
                error: Ribrit.form.response
            });

            return false;
        },

        run: function () {
            Ribrit.order.formValidate();
        }
    },

    fire: function () {
        Ribrit.scrollUp();
        Ribrit.mainMenu();
        Ribrit.google.run();
        Ribrit.flexslider.run();
        Ribrit.magnific.run();
        Ribrit.socialShare.run();
        Ribrit.form.run();
        Ribrit.cart.run();
        Ribrit.order.run();
    }
}

$(document).ready(function () {
    Ribrit.fire();
});